export default class ForecastDiarizadoEstoqueConsumido {
  id: number;
  codigoFornecedorSap: number;
  numeroContrato: string;
  codigoSku: number;
  centro: number;
  percentualConsumido: number;
  quantidade: number;
  mesAnoReferencia: number;
  dia: Date;

  constructor(
    id: number,
    codigoFornecedorSap: number,
    numeroContrato: string,
    codigoSku: number,
    centro: number,
    quantidade: number,
    mesAnoReferencia: number,
    dia: Date
  ) {
    this.id = id;
    this.codigoFornecedorSap = codigoFornecedorSap;
    this.numeroContrato = numeroContrato;
    this.codigoSku = codigoSku;
    this.centro = centro;
    this.percentualConsumido = 0;
    this.quantidade = quantidade;
    this.mesAnoReferencia = mesAnoReferencia;
    this.dia = dia;
  }

  setPercentualConsumido(percentualConsumido: number): void {
    this.percentualConsumido = percentualConsumido;
  }

  static toJson(forecastEstoqueConsumido: ForecastDiarizadoEstoqueConsumido): string {
    return JSON.stringify(forecastEstoqueConsumido);
  }

  static fromJson(json: object[]): ForecastDiarizadoEstoqueConsumido[] {
    let forecastEstoqueConsumido: ForecastDiarizadoEstoqueConsumido[] = [];
    json.forEach((item: any) => {
      forecastEstoqueConsumido.push(
        new ForecastDiarizadoEstoqueConsumido(
          item["id"],
          item["codigoFornecedorSap"],
          item["numeroContrato"],
          item["codigoSku"],
          item["centro"],
          item["quantidade"],
          item["mesAnoReferencia"],
          item["dia"]
        )
      );
    });
    return forecastEstoqueConsumido;
  }
}
